"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9781],{

/***/ 49781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ SvgIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21483);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79690);
/* harmony import */ var _icons_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92374);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSvgIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span(styled_system__WEBPACK_IMPORTED_MODULE_2__.space, ({ imageUrl, color, themeColor, theme, size }) => `
    mask: url("${imageUrl}");
    display: inline-block;
    width: ${size || 50}px;
    height: ${size || 50}px;
    background-color: var(--button-icon-color, 
      ${themeColor && (theme.brand[themeColor] || theme.colors[themeColor]) || color || theme.colors.gray600});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `);
const SvgIcon = (_a) => {
  var _b = _a, {
    name,
    onClick
  } = _b, props = __objRest(_b, [
    "name",
    "onClick"
  ]);
  const imageUrl = _icons_es_js__WEBPACK_IMPORTED_MODULE_3__/* .iconMap */ .q[name];
  if (!imageUrl) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSvgIcon, __spreadValues({
    onClick,
    imageUrl
  }, props));
};




/***/ }),

/***/ 92374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ iconMap; },
  "c": function() { return /* binding */ icons; }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/account.es.js
var account = "https://shopfront-cdn.tekoapis.com/static/360d583357852b95.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/checklist.es.js
var checklist = "https://shopfront-cdn.tekoapis.com/static/58a618ad98de3016.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/cpu.es.js
var cpu = "https://shopfront-cdn.tekoapis.com/static/a4b4d772feed1003.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/promo.es.js
var promo = "https://shopfront-cdn.tekoapis.com/static/5f10c2b8b58ef165.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/search.es.js
var search = "https://shopfront-cdn.tekoapis.com/static/dc6de02b661eb31c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/shopping-cart.es.js
var shoppingCart = "https://shopfront-cdn.tekoapis.com/static/8ef484d2d38f9da8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/free-shipping.es.js
var freeShipping = "https://shopfront-cdn.tekoapis.com/static/64c212730613c00d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/close.es.js
var close_es_close = "https://shopfront-cdn.tekoapis.com/static/0364832d695974bf.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-up.es.js
var chevronUp = "https://shopfront-cdn.tekoapis.com/static/5a2fda8b57935427.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-down.es.js
var chevronDown = "https://shopfront-cdn.tekoapis.com/static/c07673d71acde799.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-back.es.js
var chevronBack = "https://shopfront-cdn.tekoapis.com/static/fe7f8bf76f2b838c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-forward.es.js
var chevronForward = "https://shopfront-cdn.tekoapis.com/static/a655221bd64cacf4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/location.es.js
var location_es_location = "https://shopfront-cdn.tekoapis.com/static/8cd2ac5f60caff4e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/add-outline.es.js
var addOutline = "https://shopfront-cdn.tekoapis.com/static/949377dd1535d300.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/home.es.js
var home = "https://shopfront-cdn.tekoapis.com/static/03ae0aa735763beb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/grid.es.js
var grid = "https://shopfront-cdn.tekoapis.com/static/bdd63e78510785e1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/notifications.es.js
var notifications = "https://shopfront-cdn.tekoapis.com/static/96f7d19e0c6e8841.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/trash.es.js
var trash = "https://shopfront-cdn.tekoapis.com/static/e0fc0c2da71993c2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/guarantee-checked.es.js
var guarantee = "https://shopfront-cdn.tekoapis.com/static/61b88b0a6893d3b0.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/help.es.js
var help = "https://shopfront-cdn.tekoapis.com/static/a0ef8604f5a51c92.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/product.es.js
var product = "https://shopfront-cdn.tekoapis.com/static/7de71eb80b44de2e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/favorite.es.js
var favorite = "https://shopfront-cdn.tekoapis.com/static/6859bf852118defe.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/flash-sale.es.js
var flashSale = "https://shopfront-cdn.tekoapis.com/static/b0b6d87219b43554.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-facebook.es.js
var logoFacebook = "https://shopfront-cdn.tekoapis.com/static/4a245cee42ae6bbb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-youtube.es.js
var logoYoutube = "https://shopfront-cdn.tekoapis.com/static/2d3d889a92325278.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-tiktok.es.js
var logoTiktok = "https://shopfront-cdn.tekoapis.com/static/28e4a3a78ca94c96.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-instagram.es.js
var logoInstagram = "https://shopfront-cdn.tekoapis.com/static/e9acf6e5447bc6f5.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/community.es.js
var community = "https://shopfront-cdn.tekoapis.com/static/c71967f1b568ff35.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/call.es.js
var call = "https://shopfront-cdn.tekoapis.com/static/cb825a96c16aeade.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/qr-code.es.js
var qrCode = "https://shopfront-cdn.tekoapis.com/static/7534c48e46ec507e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/time.es.js
var time = "https://shopfront-cdn.tekoapis.com/static/b2c29b7046b45840.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/card.es.js
var card = "https://shopfront-cdn.tekoapis.com/static/abf02ec95226fd05.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/cash.es.js
var cash = "https://shopfront-cdn.tekoapis.com/static/0e924ede5a93187b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/star.es.js
var star = "https://shopfront-cdn.tekoapis.com/static/6571a6180d3cbf15.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/down.es.js
var down = "https://shopfront-cdn.tekoapis.com/static/06a44350362fc960.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/up.es.js
var up = "https://shopfront-cdn.tekoapis.com/static/91d02f8bbc1b94f9.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/percentage.es.js
var percentage = "https://shopfront-cdn.tekoapis.com/static/fc6f3b4f8e2c8800.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/tag.es.js
var tag = "https://shopfront-cdn.tekoapis.com/static/08ed682a05c137e9.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/circle-close.es.js
var circleClose = "https://shopfront-cdn.tekoapis.com/static/511986a5e2d4e41e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/cash-color.es.js
var cashColor = "https://shopfront-cdn.tekoapis.com/static/fae4d10b55525aea.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/promotion-fill.es.js
var promotionFill = "https://shopfront-cdn.tekoapis.com/static/a2125525237c799e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/plus-default.es.js
var plusDefault = "https://shopfront-cdn.tekoapis.com/static/1cbd090c04c530bc.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/cash-outline.es.js
var cashOutline = "https://shopfront-cdn.tekoapis.com/static/0e924ede5a93187b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/caution.es.js
var caution = "https://shopfront-cdn.tekoapis.com/static/a1690276bae7d213.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/edit.es.js
var edit = "https://shopfront-cdn.tekoapis.com/static/849013b6dba79f68.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/return-product.es.js
var returnProduct = "https://shopfront-cdn.tekoapis.com/static/ea6d2b8854995476.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/freeshipping-outline.es.js
var freeshippingOutline = "https://shopfront-cdn.tekoapis.com/static/cedacbcaec1a1651.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/freeshipping-color.es.js
var freeshippingColor = "https://shopfront-cdn.tekoapis.com/static/0e5c8af0b6cd0275.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/success.es.js
var success = "https://shopfront-cdn.tekoapis.com/static/16aee9ad56e6c90c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/setting.es.js
var setting = "https://shopfront-cdn.tekoapis.com/static/e9b67a3d2e93b5be.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/laptop.es.js
var laptop = "https://shopfront-cdn.tekoapis.com/static/86553a12f72c9c94.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/shape.es.js
var voucher = "https://shopfront-cdn.tekoapis.com/static/90b396a842b085f8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-google.es.js
var logoGoogle = "https://shopfront-cdn.tekoapis.com/static/d7b3d575b3e8fc03.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/time-outline.es.js
var timeOutline = "https://shopfront-cdn.tekoapis.com/static/b2c29b7046b45840.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/trending-up-outline.es.js
var trendingUpOutline = "https://shopfront-cdn.tekoapis.com/static/f8a98e7b6265d7ec.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/promotion.es.js
var promotion = "https://shopfront-cdn.tekoapis.com/static/251a15c03b923c4b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/menu.es.js
var menu = "https://shopfront-cdn.tekoapis.com/static/789d831c0ec23c90.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/arrow_down.es.js
var arrowDown = "https://shopfront-cdn.tekoapis.com/static/e2d2f7be6dc83ff2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/photo.es.js
var photo = "https://shopfront-cdn.tekoapis.com/static/c486cae13baa79ad.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/excel.es.js
var excel = "https://shopfront-cdn.tekoapis.com/static/56ef3890145be03a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/messenger-logo.es.js
var messenger = "https://shopfront-cdn.tekoapis.com/static/71a0547de8dec349.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/pdf.es.js
var pdf = "https://shopfront-cdn.tekoapis.com/static/c88ca7dfb6a0adbd.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/tick.es.js
var tick = "https://shopfront-cdn.tekoapis.com/static/df90022c2d1adbfb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/error.es.js
var error = "https://shopfront-cdn.tekoapis.com/static/0e3c0ac5500f8b8c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/bell.es.js
var bell = "https://shopfront-cdn.tekoapis.com/static/c71543de0a174eaf.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/buildpc.es.js
var buildpc = "https://shopfront-cdn.tekoapis.com/static/4c02f4e5830e527a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/envelope.es.js
var envelope = "https://shopfront-cdn.tekoapis.com/static/a66400b1ee8416d3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/showroom.es.js
var showroom = "https://shopfront-cdn.tekoapis.com/static/b0d0161a0c69c7a1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/support.es.js
var support = "https://shopfront-cdn.tekoapis.com/static/f5ca93aa40fe18ed.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/warranty.es.js
var warranty = "https://shopfront-cdn.tekoapis.com/static/7d9576602ab21004.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/journalist.es.js
var journalist = "https://shopfront-cdn.tekoapis.com/static/fd30b8db36d9b1e3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chat.es.js
var chat = "https://shopfront-cdn.tekoapis.com/static/aaf120a4ce138b4c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/cpu-icon.es.js
var cpuIcon = "https://shopfront-cdn.tekoapis.com/static/3d7140d43b672ba4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/mother-board-icon.es.js
var motherBoard = "https://shopfront-cdn.tekoapis.com/static/7bf562748dccb296.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/RAM-icon.es.js
var ram = "https://shopfront-cdn.tekoapis.com/static/5a9f38ba2258d73d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/hard-disk-icon.es.js
var hdd = "https://shopfront-cdn.tekoapis.com/static/e95dec823dfc9cba.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/ssd-disk-icon.es.js
var ssd = "https://shopfront-cdn.tekoapis.com/static/f9387823f4497274.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/grphics-card-icon.es.js
var vga = "https://shopfront-cdn.tekoapis.com/static/a54a3adf0f0f78ab.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/power-icon.es.js
var power = "https://shopfront-cdn.tekoapis.com/static/8c661c8671413d6f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/chassis-icon.es.js
var chassis = "https://shopfront-cdn.tekoapis.com/static/d1303b3e3941860c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/heat-sink-icon.es.js
var heatSink = "https://shopfront-cdn.tekoapis.com/static/d2202e2b35bcb4db.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/monitor-icon.es.js
var monitor = "https://shopfront-cdn.tekoapis.com/static/7a92580cceeadb46.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/keyboard-icon.es.js
var keyboard = "https://shopfront-cdn.tekoapis.com/static/c1839840a81c5861.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/mouse-icon.es.js
var mouse = "https://shopfront-cdn.tekoapis.com/static/56345fd3fd3da76d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/gift.es.js
var gift = "https://shopfront-cdn.tekoapis.com/static/2b8403d1ea147a23.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/dino.es.js
var dino = "https://shopfront-cdn.tekoapis.com/static/586024ada7459afb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/dino-icon.es.js
var dinoIcon = "https://shopfront-cdn.tekoapis.com/static/fc13827d222b8c0d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/more-info.es.js
var moreInfo = "https://shopfront-cdn.tekoapis.com/static/98504a319c079288.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/grid-layout.es.js
var gridLayout = "https://shopfront-cdn.tekoapis.com/static/aae8334388f296cc.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/list-layout.es.js
var listLayout = "https://shopfront-cdn.tekoapis.com/static/10a387fb698bb09d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/filter.es.js
var filter = "https://shopfront-cdn.tekoapis.com/static/fc1421026697d60f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/filter-sort-by.es.js
var filterSortBy = "https://shopfront-cdn.tekoapis.com/static/3c8bba9fb4200565.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/check.es.js
var check = "https://shopfront-cdn.tekoapis.com/static/d2123313b305a219.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/news.es.js
var news = "https://shopfront-cdn.tekoapis.com/static/3a4cd6f50be1dbbb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/upload.es.js
var upload = "https://shopfront-cdn.tekoapis.com/static/c12fdd40ddee1ea3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/caret-down.es.js
var caretDown = "https://shopfront-cdn.tekoapis.com/static/4c1c0e464c3b7961.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/more.es.js
var more = "https://shopfront-cdn.tekoapis.com/static/8e70a9b045206df7.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/clock.es.js
var clock = "https://shopfront-cdn.tekoapis.com/static/c1ea89899161ab54.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/checkbox.es.js
var checkbox_es_checkbox = "https://shopfront-cdn.tekoapis.com/static/2325f68c1e3eab10.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/plus.es.js
var plus = "https://shopfront-cdn.tekoapis.com/static/f04b3233a3780d10.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/subtract.es.js
var subtract = "https://shopfront-cdn.tekoapis.com/static/61d838e201b3d02d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/bag_checkmark.es.js
var bag_checkmark = "https://shopfront-cdn.tekoapis.com/static/97ff32f4d297003f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/download.es.js
var download = "https://shopfront-cdn.tekoapis.com/static/1a12d49243365c56.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logout.es.js
var logout = "https://shopfront-cdn.tekoapis.com/static/ab3ea40352f63ad2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/calendar.es.js
var calendar = "https://shopfront-cdn.tekoapis.com/static/3c2b47d8956c44b3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/phone.es.js
var phone = "https://shopfront-cdn.tekoapis.com/static/82e24372ab515af4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/business-person.es.js
var businessPerson = "https://shopfront-cdn.tekoapis.com/static/22eb9c4eaaae04c3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/Plus-circle.es.js
var plusCircle = "https://shopfront-cdn.tekoapis.com/static/35b9af99a5fd3532.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/letter.es.js
var letter = "https://shopfront-cdn.tekoapis.com/static/95bf036e0047e5de.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/return-vnd.es.js
var returnVnd = "https://shopfront-cdn.tekoapis.com/static/c70fd35508218057.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/report-sold.es.js
var reportSold = "https://shopfront-cdn.tekoapis.com/static/19a896d6b4db97b8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/sellout.es.js
var sellOut = "https://shopfront-cdn.tekoapis.com/static/7efaee58ad023c8f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/reports.es.js
var reports = "https://shopfront-cdn.tekoapis.com/static/9ac20b6cb17519be.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/minus.es.js
var minus = "https://shopfront-cdn.tekoapis.com/static/541582955daa66c1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/refresh.es.js
var refresh = "https://shopfront-cdn.tekoapis.com/static/07001edfcdc8d627.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/voucher-cash.es.js
var voucherCash = "https://shopfront-cdn.tekoapis.com/static/1217c4c74ed67be1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/loyalty.es.js
var loyalty = "https://shopfront-cdn.tekoapis.com/static/fedbd47700ec8fe6.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/zalo.es.js
var zalo = "https://shopfront-cdn.tekoapis.com/static/20f9b470a01bcc4e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/share.es.js
var share = "https://shopfront-cdn.tekoapis.com/static/7c85713d791fb634.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/email.es.js
var email = "https://shopfront-cdn.tekoapis.com/static/22f44138cac1453a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-zalo.es.js
var logoZalo = "https://shopfront-cdn.tekoapis.com/static/98a2b9aacbb59a62.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/linkedin.es.js
var linkedin = "https://shopfront-cdn.tekoapis.com/static/c45c0304dbe3b0ac.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/images/id-card.es.js
var idCart = "https://shopfront-cdn.tekoapis.com/static/66485d061b21552d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-a7834445b9/1/packages/ui/dist/components/atoms/SvgIcon/icons.es.js




























































































































const iconMap = {
  account: account,
  checklist: checklist,
  cpu: cpu,
  promo: promo,
  search: search,
  "shopping-cart": shoppingCart,
  "free-shipping": freeShipping,
  close: close_es_close,
  "chevron-up": chevronUp,
  "chevron-down": chevronDown,
  location: location_es_location,
  "add-outline": addOutline,
  "chevron-back": chevronBack,
  "chevron-forward": chevronForward,
  home: home,
  grid: grid,
  notifications: notifications,
  trash: trash,
  guarantee: guarantee,
  help: help,
  product: product,
  favorite: favorite,
  "flash-sale": flashSale,
  "logo-facebook": logoFacebook,
  "logo-youtube": logoYoutube,
  community: community,
  call: call,
  "qr-code": qrCode,
  time: time,
  card: card,
  cash: cash,
  star: star,
  down: down,
  up: up,
  percentage: percentage,
  tag: tag,
  "circle-close": circleClose,
  "cash-color": cashColor,
  "promotion-fill": promotionFill,
  "plus-default": plusDefault,
  "cash-outline": cashOutline,
  caution: caution,
  edit: edit,
  "return-product": returnProduct,
  "freeshipping-outline": freeshippingOutline,
  "freeshipping-color": freeshippingColor,
  success: success,
  setting: setting,
  laptop: laptop,
  voucher: voucher,
  "logo-google": logoGoogle,
  "time-outline": timeOutline,
  "trending-up-outline": trendingUpOutline,
  promotion: promotion,
  menu: menu,
  photo: photo,
  excel: excel,
  "arrow-down": arrowDown,
  messenger: messenger,
  pdf: pdf,
  tick: tick,
  error: error,
  bell: bell,
  buildpc: buildpc,
  envelope: envelope,
  showroom: showroom,
  support: support,
  warranty: warranty,
  journalist: journalist,
  chat: chat,
  "cpu-icon": cpuIcon,
  "mother-board": motherBoard,
  ram: ram,
  hdd: hdd,
  ssd: ssd,
  vga: vga,
  power: power,
  chassis: chassis,
  "heat-sink": heatSink,
  monitor: monitor,
  keyboard: keyboard,
  mouse: mouse,
  gift: gift,
  dino: dino,
  "dino-icon": dinoIcon,
  more: more,
  "more-info": moreInfo,
  "grid-layout": gridLayout,
  "list-layout": listLayout,
  filter: filter,
  "filter-sort-by": filterSortBy,
  check: check,
  news: news,
  "caret-down": caretDown,
  upload: upload,
  clock: clock,
  checkbox: checkbox_es_checkbox,
  plus: plus,
  subtract: subtract,
  "bag-checkmark": bag_checkmark,
  download: download,
  logout: logout,
  calendar: calendar,
  phone: phone,
  "business-person": businessPerson,
  "plus-circle": plusCircle,
  letter: letter,
  "return-vnd": returnVnd,
  "report-sold": reportSold,
  sellout: sellOut,
  reports: reports,
  minus: minus,
  refresh: refresh,
  "voucher-cash": voucherCash,
  loyalty: loyalty,
  zalo: zalo,
  share: share,
  "logo-tiktok": logoTiktok,
  "logo-instagram": logoInstagram,
  email: email,
  "logo-zalo": logoZalo,
  linkedin: linkedin,
  "id-card": idCart
};
const icons = Object.keys(iconMap);




/***/ })

}]);